import React, { useEffect, useState } from 'react';
import { Input } from 'antd';
import { ImageBox } from '@bvt-shared/component/ImageBox';
import { useMainOpenProject } from '@bvt-features/mapp/mainOpen/hooks';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import IMAGE_CABINET from '@bvt-assets/images/CabinetIllustration.png';

import './PertaminaListGrianaContainer.scss';
import { Loading } from '@bvt-features/account/component';

/**
 *
 * @param {object} props
 * @param {(cb: { projectID: string, processID: string }) => void} props.onClick
 */

export const PertaminaListGrianaContainer = (props) => {
  const project = useMainOpenProject();
  const [input, setInput] = useState('');
  const [page, setPage] = useState(1);
  const [projectList, setProjectList] = useState([]);
  const meta = project.state.properties || {
    total: 0,
  };
  const maxPage = Math.ceil(+meta.total / 50);

  const metaParams = {
    meta: {
      filter: {
        name: input,
        project_type: 'Analysis - Grid Profiling',
        status: 'success',
        isAddons: true,
      },
      pageSize: 50,
      page: 1,
      sort: {
        by: 'lastupdate',
        type: 'DESC',
      },
    },
  };

  useEffect(() => {
    setPage(1);
    project.getAllProject(metaParams);

    return () => {
      project.resetState();
    };
  }, []);

  useEffect(() => {
    if (project.state.list) {
      setProjectList((prev) => [...prev, ...project.state.list]);
    }
  }, [project.state.list]);

  const fetchMoreData = () => {
    if (page < maxPage) {
      setPage((prevPage) => prevPage + 1);
      project.getAllProject({
        ...metaParams,
        meta: {
          ...metaParams.meta,
          page: page + 1,
        },
      });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      setPage(1);
      setProjectList([]);
      project.getAllProject(metaParams);
    }
  };

  const suffix =
    input?.length > 0 ? (
      <ImageBox
        className='search'
        onClick={() => {
          setInput('');
          setPage(1);
          setProjectList([]);
          project.getAllProject({
            ...metaParams,
            meta: {
              ...metaParams.meta,
              filter: {
                ...metaParams.meta.filter,
                name: '',
              },
            },
          });
        }}
        src='ic-close'
      />
    ) : (
      <ImageBox
        className='search'
        onClick={(e) => {
          e.stopPropagation();
        }}
        src='ic-search'
      />
    );

  const loader = (
    <div className='no_data'>
      <Loading />
    </div>
  );

  const noData = (
    <div className='no_data'>
      <div>
        <img alt='no data' src={IMAGE_CABINET} />
        <div className='no_data__title'>No Projects Found</div>
        <div className='no_data__desc'>
          You haven’t created any grid analysis yet.
          <br /> Create your first one in
          <strong> Map Analytic</strong> to start exploring spatial insights.
        </div>
      </div>
    </div>
  );

  const list = projectList.map((v) => (
    <div
      className='item-wrapper'
      key={v.id}
      onClick={() => {
        props?.onClick?.({
          projectID: v.id,
          processID: v.task.UUID,
          name: v.name,
        });
      }}
    >
      <div className='item'>
        <div className='item-top'>
          <div className='item-top-left'>
            <div className='name'>{v.name}</div>
          </div>
          <div className='item-top-right'>
            <span>Last Updated</span>
            <div>
              {moment(v.updated_at ?? v.created_at).fromNow()}
            </div>
          </div>
        </div>
        <div className='item-bottom'>
          {v.administrative?.province?.name}, {v.administrative?.regency?.name}
        </div>
      </div>
    </div>
  ));

  const renderList = projectList.length > 0 ? list : noData;

  return (
    <div className='PertaminaListGrianaContainer'>
      <div className='input-wrapper'>
        <div className='input'>
          <Input
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder='Search grid analysis'
            suffix={suffix}
            value={input}
          />
        </div>
      </div>
      <div className='list' id='scrollableDiv'>
        <InfiniteScroll
          dataLength={projectList.length}
          hasMore={page < maxPage}
          initialScrollY={0}
          loader={loader}
          next={fetchMoreData}
          scrollableTarget='scrollableDiv'
        >
          {projectList.length === 0 && project.state.status_GET === 'LOADING'
            ? loader
            : renderList}
        </InfiniteScroll>
      </div>
    </div>
  );
};
